import React from "react";
import { IOcrProcessLineItem } from "./OcrProcessDisplay";

interface OcrProcessLineItemProps {
  item: IOcrProcessLineItem;
}

export function statusToClass(status: number) {
  if (status === 0) {
    return "offen";
  }
  if (status === 1) {
    return "eingereicht";
  }
  if (status === 2) {
    return "erstattet";
  }
  if (status === 3) {
    return "einspruch";
  }
  if (status === 4) {
    return "abgeschlossen";
  }

  return "nachforderung";
}

export function pickStatus(item: IOcrProcessLineItem) {
  const overallStatus = item.status;
  const bhStatus = item.bhStatus;
  const vuStatus = item.vuStatus;

  // Old database entry, default to old status
  if (bhStatus === -1 && vuStatus === -1) {
    return overallStatus;
  }

  // Same status for both, use that.
  if (bhStatus === vuStatus) {
    return bhStatus;
  }

  // Use the remaining status flags in order of importance:

  // Widerspruch
  if (bhStatus === 3 || vuStatus === 3) {
    return 3;
  }

  // Nachforderung
  if (bhStatus === 5 || vuStatus === 5) {
    return 5;
  }

  // Begr. Kürzung
  if (bhStatus === 7 || vuStatus === 7) {
    return 7;
  }

  // Offen
  if (bhStatus === 0 || vuStatus === 0) {
    return 0;
  }

  // Eingereicht
  if (bhStatus === 1 || vuStatus === 1) {
    return 1;
  }

  // Erstattet
  if (bhStatus === 2 || vuStatus === 2) {
    return 2;
  }

  // Abgeschlossen
  if (bhStatus === 4 || vuStatus === 4) {
    return 4;
  }

  // This is unreachable, but we need to return something to placate the type
  // checker.
  return -1;
}

export default class OcrProcessTable extends React.Component<OcrProcessLineItemProps> {
  badgeSpan(key: string, tag: string) {
    return (
      <span key={key} className="badge mr-2">
        {" "}
        {tag}
      </span>
    );
  }

  render() {
    const statusNumber = pickStatus(this.props.item);
    const statusString = statusToClass(statusNumber);

    let humanReadableStatus = "Offen";
    if (statusNumber === 1) {
      humanReadableStatus = "Eingereicht";
    } else if (statusNumber === 2) {
      humanReadableStatus = "Erstattet";
    } else if (statusNumber === 3) {
      humanReadableStatus = "Widerspruch";
    } else if (statusNumber === 4) {
      humanReadableStatus = "Abgeschlossen";
    } else if (statusNumber === 5) {
      humanReadableStatus = "Nachforderung";
    } else if (statusNumber === 7) {
      humanReadableStatus = "Begr. Kürzung";
    }

    return (
      <tr className={`status--${statusString}`}>
        <td className="indicatorbg">
          <div className="indicator">&nbsp;{humanReadableStatus}</div>
        </td>
        <td>{this.props.item.receiptNumber}</td>
        <td>{this.props.item.receiptClass}</td>
        <td className="nowrap">{this.props.item.behandlungsdatum}</td>
        <td className="nowrap150">{this.props.item.accountHolderName}</td>
        <td>{this.props.item.receiptSum}</td>
        <td>{this.props.item.erstattungSum}</td>
        <td>{this.props.item.receiptDate}</td>
        <td>{this.props.item.extReceiptNumber}</td>
        <td>{this.props.item.leistungPkvPpv}</td>
        <td>{this.props.item.leistungBeihilfe}</td>
        <td>{this.props.item.eigenanteil}</td>
        <td>
          <span>{this.props.item.paidOn}</span>
          <a href="#">
            <span
              className={`icon icon-${
                this.props.item.paidOn ? "cancel" : "ok-circled"
              }`}
            />
          </a>
        </td>
      </tr>
    );
  }
}
